/////////////////////////////////////////////////////////////////////////
// This library abstract the jquery post request
// This is helpful to be able to hook any request errors to the server
// by using ConnSettings configuarations
/////////////////////////////////////////////////////////////////////////
// Imports
import * as $ from 'jquery';
import { isDefined, isObject } from './Micro';
import { UserManager } from './UserManager';
/////////////////////////////////////////////////////////////////////////

// TODO: Rename the library...
// ------------------------------------------------------
export interface ConnHeaders { [key: string]: any; }
// ------------------------------------------------------
export interface ConnSettings {
    url: string;
    /**
     * AJAX's request body.
     */
    dataOut?: Object | string;
    /**
     * AJAX's request headers.
     */
    headers?: ConnHeaders;
    /**
     * Callback when AJAX request is successful.
     */
    success?: (dataIn: any, textStatus: string, jqXHR: JQueryXHR) => void;
    dataType?: string;
    /**
     * Callback when AJAX request fails. Note: not called when status error code is 403.
     */
    failed?: (jqXHR: JQueryXHR, textStatus: string) => void;
    /**
     * Callback when AJAX request fails with status code 403.
     */
    onUnauthorizedRequest?: (url: string, jqXHR: JQueryXHR) => void;
    /**
     * Callback when AJAX request is finished.
     * Note: called after success/failed/onUnauthorizedRequest callbacks.
     */
    complete?: (jqXHR: JQueryXHR, textStatus: string) => any;

    /**
     * Extra AjaxSettings
     */
    ajaxSettings?: JQueryAjaxSettings;
}
// ------------------------------------------------------
export class Conn {
    // ------------------------------------------------------
    private static CsrfHeaderName: string = "NCSRF";
    // ------------------------------------------------------
    public static SetCsrfHeaderName(CsrfHeaderName: string = "NCSRF") {
        Conn.CsrfHeaderName = CsrfHeaderName;
    }
    // ------------------------------------------------------
    public static loginPathHeader: string = 'Login-Path';
    // ------------------------------------------------------
    public static post(opt: ConnSettings): JQueryXHR {
        return Conn.request("POST", opt);
    }
    // ------------------------------------------------------
    public static get(opt: ConnSettings): JQueryXHR {
        return Conn.request("GET", opt);
    }
    // ------------------------------------------------------
    public static put(opt: ConnSettings): JQueryXHR {
        return Conn.request("PUT", opt);
    }
    // ------------------------------------------------------
    public static delete(opt: ConnSettings): JQueryXHR {
        return Conn.request("DELETE", opt);
    }
    // ------------------------------------------------------------------------------------------------------
    public static getCsrfHeader(token: string): ConnHeaders {
        const headers: ConnHeaders = {};
        headers[Conn.CsrfHeaderName] = token;
        return headers;
    }
    // ------------------------------------------------------
    public static request(method: string, opt: ConnSettings): JQueryXHR {
        try {
            var ajaxSettings: JQueryAjaxSettings;
            if (isDefined(opt.ajaxSettings)) {
                ajaxSettings = opt.ajaxSettings;
                ajaxSettings.url = opt.url;
                ajaxSettings.method = method;
                ajaxSettings.type = method;
            } else {
                ajaxSettings = {
                    url: opt.url,
                    method: method,
                    type: method
                };
            }

            // Set data if exists
            if (isDefined(opt.dataOut)) {
                if (isObject(opt.dataOut) && method != "GET") {
                    ajaxSettings.data = JSON.stringify(opt.dataOut);
                    ajaxSettings.contentType = 'application/json';
                }
                else
                    ajaxSettings.data = opt.dataOut;
            }

            // Set headers if exists
            if (isDefined(opt.headers))
                ajaxSettings.headers = opt.headers;

            // Set dataType if exists
            if (isDefined(opt.dataType))
                ajaxSettings.dataType = opt.dataType;

            // Set complete callback if exists
            if (isDefined(opt.complete))
                ajaxSettings.complete = opt.complete;

            // Put user tokens
            if (process.env.GLOW_BUILD) {
                if (ajaxSettings.headers == null)
                    ajaxSettings.headers = {};
                let userManager = UserManager.GetInstance();
                let accessToken = userManager.getAccessToken();
                ajaxSettings.headers["Authorization"] = `Bearer ${accessToken}`;
            }

            // Init request
            var ajaxRequest = $.ajax(ajaxSettings);

            // Handling done
            if (isDefined(opt.success)) {
                ajaxRequest.done((msg, txt, xhr) => {
                    opt.success(msg, txt, xhr);
                });
            }

            // Handling failed
            ajaxRequest.fail((jqXHR, textStatus) => {
                console.log("Request failed: " + textStatus);
                // catch response with status code 403
                if ((jqXHR.status === 403 || jqXHR.status === 401) &&
                    isDefined(opt.onUnauthorizedRequest)) {
                    opt.onUnauthorizedRequest(opt.url, jqXHR);
                }
                else {
                    if (isDefined(opt.failed)) {
                        opt.failed(jqXHR, textStatus);
                    }
                }
            });
        } catch (e) {
            console.error(e);
        }
        return ajaxRequest;
    }
    // ------------------------------------------------------
}